// @flow

import { type ViewportCategory } from '@ta/common.state';

export { default as AchievementsAPIQuery } from './AchievementAPI.gql';
export {
  default as MemberFolloweeCountFragment,
} from './feedFragments/MemberFolloweeCount.fragment.gql';
export { default as MixerAPIQuery } from './MixerApiV2.gql';
export { default as ProfileQueryWithUserId } from './ProfilesByIds.gql';
export { default as TermsOfUseQuery } from './TermsOfUseQuery.gql';
export { default as GeoOverviewQuery } from './GeoOverview.gql';
export { default as DmoCompetitorQuery } from './DmoCompetitor.gql';
export { default as ReportCollapsedFeedSection } from './ReportCollapsedFeedSection.gql';
export {
  default as FeedObjectStatisticFieldsFragment,
} from './feedFragments/FeedObjectStatisticFields.fragment.gql';

export {
  default as ContributionCountFragment,
} from './feedFragments/ContributionCount.fragment.gql';

export const sessionType = (viewportCategory: ViewportCategory) => {
  switch (viewportCategory) {
    case 'DESKTOP':
      return 'DESKTOP';
    case 'TABLET':
      return 'TABLET_WEB';
    case 'MOBILE':
      return 'MOBILE_WEB';
    default:
      return 'OTHER';
  }
};

export {
  default as QueryWithPartialRefetchUntilReactApollo220Release,
} from './QueryWithPartialRefetchUntilReactApollo220Release';

export { default as SponsoredHomeQuery } from './SponsoredHomeQuery.gql';

export { default as CanBoostQuery } from './CanBoostQuery.gql';
